import { ETHERSCAN_API_KEY } from '../../config/constants';
import Log from '../../utils/Log';

export const FETCH_ACTIVITY = 'FETCH_ACTIVITY';

/**
 * Fetch the users activity use the https://etherscan.io/apis.
 *
 * Note that currently we fetch a list of all transactions between
 * the user's active wallet and StickSports in order to present a
 * link for each transaction at Etherscan. i.e.
 *
 * http://api.etherscan.io/api?module=account&action=txlist&address=0xc887b9ddd178cbf34768c6aefd551f9e5ee9f2ab&startblock=0&endblock=latest&sort=asc&apikey=Q4WM4W3Q1PIX5RREZ458IFENEVTC48TGRD ()
 *
 * In the future, we can look at determining a item ID by decoding
 * "input" field fro each transaction i.e.
 *
 * https://www.etherchain.org/api/tx/0x2cddcd7bf70fab3ed9412f2e93a986189bde86f8bf6b05bd8563482d7a65f9a0
 *
 * Online tool https://etid.wtd.ru/ shows that decoding the parameters send to a contract is possible and perhaps https://github.com/miguelmota/ethereum-input-data-decoder can be used to do it from the StickSports Dapp.
 *
 *
 * @param  {[type]} web3            [description]
 * @param  {[type]} myWalletAddress [description]
 * @return {[type]}                 [description]
 */
export const fetchActivity = (web3, myWalletAddress) => async (dispatch) => {
  const address = '0xc887b9ddd178cbf34768c6aefd551f9e5ee9f2ab'; // A Mainnet addresss
  const cEOAddress = '0xb1690c08e213a35ed9bab7b318de14420fb57d8c'; // CryptoKitties wallet

  fetch(`https://api.etherscan.io/api?module=account&action=txlist&address=${address}&startblock=0&endblock=latest&sort=asc&apikey=${ETHERSCAN_API_KEY}`).then(response => {
    response.json().then(results => {
      const filteredResults = results.result.filter(result => {
          return ((result.from === address || result.to === address) &&
                  (result.from === cEOAddress || result.to === cEOAddress));
      });

      dispatch({
        type: FETCH_ACTIVITY,
        payload: filteredResults
      });
    });
  });
}

/**
 * Failed attempts to use web3 to get the users activity.
 *
 * @param  {[type]} web3            [description]
 * @param  {[type]} myWalletAddress [description]
 * @return {[type]}                 [description]
 */
export const fetchActivity_V1 = (web3, myWalletAddress) => async (dispatch) => {
  if (web3.version.api) { // web3@0.20.6
    /**
     * Action that fails to return transaction for a wallet.
     *
     * See https://github.com/ethereum/web3.js/issues/332
     *
     * @param  {[type]} this [description]
     * @return {[type]}      [description]
     */
    web3.eth.filter({
      fromBlock: '0x0',
      toBlock: 'latest',
      address: '0xccb6967311c2f1d87e00ca33e3875cc0b9196420',
      from: myWalletAddress
    }).get((error, result) => {
      console.log(result);
      if (!error) {
        dispatch({
          type: FETCH_ACTIVITY,
          payload: result
        });
      } else {
        Log.error('Error finding web3.');
      }
    });

    // This is a list of reasons why we need Etherscan and can't use getPastLogs.
    // https://ethereum.stackexchange.com/questions/22954/mistake-when-using-web3-eth-filter-and-filter-get
    // https://ethereum.stackexchange.com/questions/8900/how-to-get-transactions-by-account-using-web3-js/8907#8907
    // https://gist.github.com/kumavis/ab8b7ce7d20e2be17417
    // https://ethereum.stackexchange.com/questions/2531/common-useful-javascript-snippets-for-geth/3478#3478
    // https://ethereum.stackexchange.com/questions/8900/how-to-get-transactions-by-account-using-web3-js
  } else { // web3@1.0.0
    web3.eth.getPastLogs({ // Also fails to return transaction for a wallet
      fromBlock: '0x0',
      toBlock: 'latest',
      address: '0xccb6967311c2f1d87e00ca33e3875cc0b9196420',
      from: myWalletAddress
    }).then(result => {
      dispatch({
        type: FETCH_ACTIVITY,
        payload: result
      });
    }).catch(err => console.log('getPastLogs failed.', err));
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/activityActions.js